exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Dosis:500,700|Open+Sans:400,400i,600,700);", ""]);

// module
exports.push([module.id, ".editor_controls__wrapper > div {\n  position: relative !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/__percy__/percy.css
// module id = 1307
// module chunks = 0